import { Box, Button, Grid, MobileStepper, useTheme } from "@mui/material";
import { useState } from "react";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";

const TakeOverDocList = ({ takeOverDocList }) => {

   const theme = useTheme();
   const [activeStep, setActiveStep] = useState(0);

  const maxSteps = validate(takeOverDocList) ?  takeOverDocList.length : 0;

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

   const takeOverDocDetailComponent = () => {
      const takeOverDocDetails = validate(takeOverDocList) ? takeOverDocList[activeStep] : undefined;
      return (
         <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Check List ID"
                variant="standard"
                placeholder="Enter Check List ID"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.checkListId : ""}
              />
              </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Internal Application ID"
                variant="standard"
                placeholder="Enter Internal Application ID"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.internalApplicationId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Title Holder Name"
                variant="standard"
                placeholder="Enter Title Holder Name"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.titleHolderName : ""}
              />
              </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="POD Number"
                variant="standard"
                placeholder="Enter POD Number"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.podNumber : ""}
              />
              </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Document Number"
                variant="standard"
                placeholder="Enter Document Number"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.documentNumber : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Document Name"
                variant="standard"
                placeholder="Enter Document Name"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.documentName : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Document Type Code"
                variant="standard"
                placeholder="Enter Document Type Code"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.documentTypeCode : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Document Type"
                variant="standard"
                placeholder="Enter Document Type"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.documentType : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Document Category Code"
                variant="standard"
                placeholder="Enter Document Category Code"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.documentCategoryCode : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Document Category"
                variant="standard"
                placeholder="Enter Document Category"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.documentCategory : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Document Date"
                variant="standard"
                placeholder="Enter Document Date"
                disabled={true}
                value={takeOverDocDetails !== undefined ? convertDateWithValidation(takeOverDocDetails.documentDate) : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Document Status"
                variant="standard"
                placeholder="Enter Document Status"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.documentStatus : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Number Of Pages"
                variant="standard"
                placeholder="Enter Number Of Pages"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.noOfPages : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Post Condition ID"
                variant="standard"
                placeholder="Enter Post Condition ID"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.postConditionId : ""}
              />
              </Grid>
              
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Post Condition"
                variant="standard"
                placeholder="Enter Post Condition"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.postCondition : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Verified ID"
                variant="standard"
                placeholder="Enter Verified ID"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.verifiedId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Verified"
                variant="standard"
                placeholder="Enter Verified"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.verified : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Verification ID"
                variant="standard"
                placeholder="Enter Verification ID"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.verificationId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Verification"
                variant="standard"
                placeholder="Enter Verification"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.verification : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Date Of Receipt"
                variant="standard"
                placeholder="Enter Date Of Receipt"
                disabled={true}
                value={takeOverDocDetails !== undefined ? convertDateWithValidation(takeOverDocDetails.dateOfReceipt) : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Follow up Date"
                variant="standard"
                placeholder="Enter Follow up Date"
                disabled={true}
                value={takeOverDocDetails !== undefined ? convertDateWithValidation(takeOverDocDetails.followupDate) : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Created By"
                variant="standard"
                placeholder="Enter Created By"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.createdBy : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Modified By"
                variant="standard"
                placeholder="Enter Modified By"
                disabled={true}
                value={takeOverDocDetails !== undefined ? takeOverDocDetails.modifiedBy : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Created Date"
                variant="standard"
                placeholder="Enter Created Date"
                disabled={true}
                value={takeOverDocDetails !== undefined ? convertDateWithValidation(takeOverDocDetails.createdDate) : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Modified Date"
                variant="standard"
                placeholder="Enter Modified Date"
                disabled={true}
                value={takeOverDocDetails !== undefined ? convertDateWithValidation(takeOverDocDetails.modifiedDate) : ""}
              />
              </Grid>
              </Grid>
      );
   }

    return(
         <AccordianContainer
          id="accord"
          title="Take Over Document List"
          initialOpen={false}
        >
        <Box sx={{ marginTop: "-1%" }}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                         <Box sx={{ display: "flex", justifyContent:"center", alignItems: "center", marginBottom: "8px"}}>
                        { maxSteps > 1 && <MobileStepper
                          variant="text"
                          steps={maxSteps}
                          position="static"
                          activeStep={activeStep}
                          sx={{ maxWidth: 400, flexGrow: 1, boxShadow: 2 }} 
                            nextButton={
                            <Button size="small" sx={{ color:"#003f7c" }} onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                                Next
                            {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                            ) : ( <KeyboardArrowRight /> )}
                           </Button>
                         }
                        backButton={
                        <Button size="small" onClick={handleBack} sx={{ color:"#003f7c" }} disabled={activeStep === 0}>
                        {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                        ) : (
                            <KeyboardArrowLeft />
                        )}
                            Back
                        </Button>
                    }
                    /> }
                    </Box>
                    </Grid>
                    { takeOverDocDetailComponent() }
        </Box>
        </AccordianContainer>
);

}

export default TakeOverDocList;